const Footer = () => {
    return ( 
        <footer className="content-footer footer bg-footer-theme">
            <div className="container-xxl d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column d-none d-lg-block">
                <div className="mb-2 mb-md-0">
                    © <a href="https://g8devt.com/" target="_blank" className="footer-link fw-medium">Notaryo Publiko</a>
                </div>
                {/*  d-lg-inline-block */}
                <div className="d-none"> 
                {/* <a href="https://themeselection.com/license/" className="footer-link me-4" target="_blank">License</a>
                <a href="https://themeselection.com/" target="_blank" className="footer-link me-4">More Themes</a>
                <a href="https://demos.themeselection.com/sneat-bootstrap-html-admin-template/documentation/" target="_blank" className="footer-link me-4">Documentation</a>
                <a href="https://themeselection.com/support/" target="_blank" className="footer-link d-none d-sm-inline-block">Support</a> */}
                </div>
            </div>
        </footer>
     );
}
 
export default Footer;